import { Fragment, useContext, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Typography } from '@mui/material';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';

//components
import { PlanDialog } from 'components/common/PlanDialog';
import StaffForm from './StaffForm';

//interfaces, schema, graphql, constants
import { ADD_TEXT, STAFF_TEXT, addNewStaffInitialValue } from 'constants/index';
import { CheckoutContext } from 'contexts/CheckoutContext';
import { AddNewStaffFormType, ModeType, StaffInputProps } from 'interfaces';
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { addNewStaffSchema } from 'validationSchema';
import { ActionType } from 'reducer/checkoutReducer';

const AddStaff = () => {
  const { dispatch } = useContext(CheckoutContext);
  const [staff, setStaff] = useState<StaffInputProps>({});
  const methods = useForm<AddNewStaffFormType>({
    resolver: yupResolver(addNewStaffSchema),
    defaultValues: addNewStaffInitialValue,
  });

  const { handleSubmit } = methods;

  const handleCloseModal = () => {
    dispatch({ type: ActionType.RESET });
    setStaff({});
  };

  const onSubmit: SubmitHandler<AddNewStaffFormType> = async (data) => {
    dispatch({ type: ActionType.SET_OPEN, open: true });
    setStaff(data);
  };

  return (
    <Fragment>
      <PlanDialog onClose={handleCloseModal} staff={staff} mode={ModeType.CREATE_STAFF} />
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box sx={flexCenterBetween}>
            <Typography variant="h5">{STAFF_TEXT}</Typography>
            <Button variant="contained" color="primary" type="submit">
              {ADD_TEXT}
            </Button>
          </Box>
          <StaffForm loading={false} />
        </form>
      </FormProvider>
    </Fragment>
  );
};

export default AddStaff;
